import apiClient from '@/lib/api-client'
import type { SessionState } from '@/types'

export const userService = {
  async getSessionState(): Promise<SessionState> {
    const response = await apiClient.get<SessionState>('/api/v1/users/me/session-state')
    return response.data
  },
}
